import { Link } from "react-router-dom";
import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <div className={styles.container}>
      <div className={styles.footerLinks}>
        <Link to={"/faq"}>
          <p className={styles.link}>FAQs</p>
        </Link>
        <Link to={"/privacy-policy"}>
          <p className={styles.link}>Privacy Policy</p>
        </Link>
        <Link to={"/terms-of-use"}>
          <p className={styles.link}>Terms Of Use</p>
        </Link>
      </div>
      <div className={styles.footerText}>
        © Copyright 2025 TASC Outsourcing . All rights reserved
      </div>
    </div>
  );
};

export default Footer;
